import { format } from "date-fns";

import type { DealStage } from "../types";

export const findDealLabel = (dealStages: DealStage[], dealValue: string) => {
  const dealStage = dealStages.find((stage) => stage.value === dealValue);
  return dealStage?.label;
};

export function getRelativeTimeString(
  dateString: string,
  locale = "en",
): string {
  const date = new Date(dateString);
  date.setHours(0, 0, 0, 0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const diff = date.getTime() - today.getTime();
  const unitDiff = Math.round(diff / (1000 * 60 * 60 * 24));

  // Check if the date is more than one week old
  if (Math.abs(unitDiff) > 7) {
    return new Intl.DateTimeFormat(locale, {
      day: "numeric",
      month: "long",
    }).format(date);
  }

  // Intl.RelativeTimeFormat for dates within the last week
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
  return ucFirst(rtf.format(unitDiff, "day"));
}

function ucFirst(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const isoDateStringRegex = /^\d{4}-\d{2}-\d{2}/;

export function formatISODateString(dateString: string | null | undefined) {
  // Defensive: si no hay fecha (oportunidades creadas vía API sin
  // expected_closing_date) o el formato es inválido, devolvemos null.
  // No throw — el caller decide qué renderizar.
  if (!dateString) return null;
  if (typeof dateString !== "string") return null;
  // Aceptamos tanto "YYYY-MM-DD" como ISO completo "YYYY-MM-DDTHH:mm:ss..."
  if (!isoDateStringRegex.test(dateString)) return null;

  // Some browsers will consider a date in the format YYYY-MM-DD as UTC,
  // which can cause off-by-one-day issues depending on the user's timezone.
  // To avoid this, we can parse the date components manually and create a
  // date object in the local timezone.
  const datePart = dateString.slice(0, 10);
  const [year, month, day] = datePart.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  if (isNaN(date.getTime())) return null;

  return format(date, "PP");
}
